import { FC } from 'react';
import { Box, BoxProps, Breakpoint, useMediaQuery, useTheme } from '@mui/material';

type HiddenProps = Omit<BoxProps, 'sx'> & { down?: Breakpoint; fixed?: boolean; up?: Breakpoint };

/**
 * Replaces MUI's deprecated `Hidden` component
 */
export const Hidden: FC<HiddenProps> = ({ up, down, fixed, ...rest }) => {
  const { breakpoints } = useTheme();

  const getMediaQuery = () => {
    if (fixed) return '(max-width:0px)';
    if (fixed === false) return '(min-width:0px)';
    if (down) return breakpoints.down(down);
    if (up) return breakpoints.up(up);
    return '(min-width:0px)';
  };

  const shouldHide = useMediaQuery(getMediaQuery());
  return shouldHide ? null : <Box {...rest} />;
};
